export default __webpack_public_path__ + "static/media/m_article.df3c33ad.png";